import React from 'react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Link as RouteLink} from 'react-router-dom'
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types'
import {blogRoute} from '../../utills/url'
import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'

const BlogBreadcrumbs = ({breadcrumbData}) => {
    const {contentFolder, parentFolder} = breadcrumbData || {}
    return (
        <Box
            margin={`${pxToRem(15)} ${pxToRem(10)}`}
            px={pxToRem(20)}
            pt={pxToRem(16)}
            sx={{
                a: {
                    fontSize: pxToRem(14),
                    fontFamily: fonts.primary,
                    color: 'black',
                    fontWeight: 600,
                    lineHeight: {base: pxToRem(20), lg: pxToRem(14)},
                    letterSpacing: pxToRem(4),
                    textTransform: 'uppercase',
                    _hover: {
                        textDecoration: 'none',
                        color: 'cav_red_separator'
                    }
                }
            }}
        >
            {breadcrumbData && Object.keys(breadcrumbData)?.length > 0 && (
                <>
                    <Link to="/blog/cavenders-ranch">{`Cavender's Ranch`}</Link>{' '}
                    <Box
                        as="span"
                        color={'cav_very_light_gray'}
                        fontSize={pxToRem(14)}
                        marginLeft={pxToRem(5)}
                        lineHeight={{base: pxToRem(20), lg: pxToRem(14)}}
                        letterSpacing={pxToRem(4)}
                    >
                        {'>'}{' '}
                    </Box>
                    <Link to={blogRoute(parentFolder?.folderId)}>{parentFolder?.folderName}</Link>{' '}
                    <Box
                        as="span"
                        color={'cav_very_light_gray'}
                        fontSize={pxToRem(14)}
                        marginLeft={pxToRem(5)}
                        lineHeight={{base: pxToRem(20), lg: pxToRem(14)}}
                        letterSpacing={pxToRem(4)}
                    >
                        {'>'}{' '}
                    </Box>
                    <Box
                        display={'inline'}
                        fontSize={pxToRem(14)}
                        fontFamily={fonts.primary}
                        fontStyle={'italic'}
                        fontWeight={600}
                        lineHeight={{base: pxToRem(20), lg: pxToRem(14)}}
                        letterSpacing={pxToRem(4)}
                        textTransform={'uppercase'}
                        dangerouslySetInnerHTML={{__html: contentFolder?.folderName}}
                    ></Box>{' '}
                </>
            )}
        </Box>
    )
}

BlogBreadcrumbs.propTypes = {
    breadcrumbData: PropTypes.any
}

export default BlogBreadcrumbs
